<template>
  <div class="pr-2">
    <div class="container-fluid px-0">
      <div class="row justify-content-center mt-5 border-20">
        <div class="col-lg-6 text-center">
          <h2 class="secondary-color">IELTS</h2>
          <!-- <h2 class="page-intro-line">Register for Free IELTS Demo Classes</h2> -->
          <!-- <h2 class="main-content-1 mt-2"> -->
          <!-- Acing the IELTS is no more a distant dream -->
          <!-- </h2> -->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="hero-img ielts-hero mt-5 col-lg-7 pt-lg-5">
        <img src="@/assets/imgs/ielt-hero-img.png" alt="" />
      </div>

      <div class="col-lg-5 pt-5 pt-lg-3">
        <form
          class="d-flex mr-md-5 flex-column align-items-center justify-content-center px-2 py-5 my-form w-100 rounded-lg shadow-lg"
          @submit.prevent="handleSubmit"
        >
          <div
            class="d-flex justify-content-between align-items-center pl-2 pb-2 w-100"
            style="align-self: baseline"
          >
            <div>
              <h2 class="">Register for Free IELTS Demo Classes</h2>
              <p style="font-size: 18px !important">Enter your details below</p>
            </div>
            <div class="mr-2 form-logo">
              <div @click="$router.push({ path: `/` })" role="button">
                <img
                  class="main-logo"
                  src="@/assets/imgs/main-logo.svg"
                  width="122px"
                />
              </div>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="name"
                >Name <span class="text-danger">*</span></label
              >
              <b-form-input
                id="name"
                size="sm"
                required
                v-model="form.name"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-input>
            </div>
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="e mail"
                >Email Address <span class="text-danger">*</span></label
              >
              <b-form-input
                id="email"
                required
                size="sm"
                v-model="form.email"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-input>
            </div>
          </div>

          <div class="row w-100">
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="mobileNumber"
                >Mobile Number <span class="text-danger">*</span></label
              >
              <b-form-input
                id="mobileNumber"
                required
                size="sm"
                v-model="form.mobileNumber"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-input>
            </div>
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="course"
                >Interested Course <span class="text-danger">*</span></label
              >
              <b-form-select
                id="course"
                required
                size="sm"
                v-model="form.course"
                :options="courseOptions"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-select>
            </div>
          </div>

          <!-- <div class="row w-100">
              
              </div> -->

          <div class="row w-100">
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="specialization"
                >Specialization <span class="text-danger">*</span></label
              >
              <b-form-select
                id="specialization"
                required
                size="sm"
                v-model="form.discipline"
                :options="specializationOptions"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-select>
            </div>
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="interestedCountry"
                >Interested Country <span class="text-danger">*</span></label
              >
              <b-form-input
                id="interestedCountry"
                required
                size="sm"
                v-model="form.interestedCountry"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-input>
            </div>
          </div>

          <div class="row w-100">
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="highestQualification"
                >Highest Qualification <span class="text-danger">*</span></label
              >
              <b-form-input
                id="highestQualification"
                required
                size="sm"
                v-model="form.highestQualification"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-input>
            </div>
            <div class="col-md-6 my-input">
              <label class="form-label-fair" for="budget"
                >Budget <span class="text-danger">*</span></label
              >
              <b-form-input
                id="budget"
                required
                size="sm"
                v-model="form.budget"
                class="w-100 rounded"
                style="height: 70% !important"
              ></b-form-input>
            </div>
          </div>

          <div class="w-100 py-3 d-flex justify-content-center">
            <button
              type="submit"
              class="btn rounded"
              :disabled="isSubmitting"
              style="background-color: #fe6d01; color: white"
            >
              {{ isSubmitting ? "Submitted" : "Submit" }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <section class="masthead hero-text-img-section mt-5">
      <div class="py-xl-4 mx-lg-3 gradient-box bg-primary-gradient">
        <ul class="intro-data">
          <li class="data">
            <h1 class="data-title">3,500+</h1>
            <p class="data-summary pt-2">Students Registered</p>
          </li>
          <li class="data">
            <h1 class="data-title">91%</h1>
            <p class="data-summary pt-2">Students got their desired score</p>
          </li>
          <li class="data">
            <h1 class="data-title">40+</h1>
            <p class="data-summary pt-2">Years of team experience</p>
          </li>
          <li class="data">
            <h1 class="data-title">34+</h1>
            <p class="data-summary pt-2">Batches weekly</p>
          </li>
        </ul>
      </div>
    </section>

    <section class="process-section section-spacing">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="text-center">
              <h2 class="main-heading-1">
                <!-- 5 Big reasons, why you should couch at Aliff -->
                5 Compelling Reasons to Choose us as your Coaching Partner
              </h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center mt-5">
          <div class="col-xl-5">
            <div class="text-center">
              <img src="@/assets/imgs/reasons.png" class="img-fluid" />
            </div>
          </div>
          <div class="offset-xl-1 col-xl-6 mt-4 mt-lg-0">
            <div>
              <ul class="list-item icon-list-item">
                <li>
                  <!-- We bring to you high quality, certified teachers with over 20+
                  years of experience -->
                  Our experienced and certified teachers have 20+ years of
                  expertise to offer you with high-quality education.
                </li>
                <li>
                  <!-- We are affordable, yet never compromise on the education we
                  bring your way -->
                  We offer affordable education without compromising on quality.
                </li>
                <li>
                  <!-- We do not take a cookie-cutter approach, but a personalized
                  unique method that is planned, keeping you in mind -->
                  We provide flexible coaching options for both weekend and
                  weekday batches.
                </li>
                <li>
                  <!-- Flexibility of coaching for weekend or weekdays batch -->
                  Our cohesive environment allows for mentoring and evaluation,
                  preparing you for the real-world tests.
                </li>
                <li>
                  <!-- We mentor & evaluate you in a cohesive environment to prepare
                  you for the real tests -->
                  Our personalized coaching approach caters to all your specific
                  needs.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="study-abroad-fair--footer text-center px-5 py-5">
      <h5>Copyright © 2024 Aliff, inc</h5>
    </section>
  </div>
</template>

<script>
import { LMS_API } from "@/config/index";
import axios from "axios";
import {
  courseOptions,
  specializationOptions,
} from "../../partials/sefDetails";

export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        course: "",
        discipline: "",
        interestedCountry: "",
        highestQualification: "",
        budget: "",
      },
      medium: null,
      isSubmitting: false,
      state: "",
      city: "",
      courseOptions,
      specializationOptions,
    };
  },
  methods: {
    async handleSubmit(e) {
      try {
        e.preventDefault();

        const requestData = {
          full_name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          field_values: [
            { name: "Budget", value: this.form.budget },
            {
              name: "Highest Qualification",
              value: this.form.highestQualification,
            },
            { name: "Expected Salary", value: this.form.course },
            { name: "Discipline", value: this.form.discipline },
            { name: "Interested Country", value: this.form.interestedCountry },
            { name: "Interested Course", value: this.form.course },
          ],
          state: this.form.state,
          city: this.form.city,
          category: "Student",
          ls_id: 87,
          m_id: this.medium,
        };

        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );
        if (response.data.status) {
          this.isSubmitting = true;
          this.resetForm();
          this.formSubmitToast();
        }

        // console.log("Form data:", requestData);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    stateOptions() {
      return stateCity.map((stateCity) => stateCity.state);
    },
    async getMyStates() {
      try {
        const res = await axios.get(LMS_API + "/form-webhook/master/states");
        this.myStates = res.data.data.map((state) => ({
          value: state.state_id,
          text: state.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },
    async handleStateChange() {
      try {
        // Make an API call to fetch cities based on the selected state_id
        const response = await axios.get(
          LMS_API + `/form-webhook/master/cities/${this.form.state}`
        );
        this.cityOptions = response.data.data.map((city) => ({
          value: city.city_id,
          text: city.name,
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    geCityOptions() {
      let currentStateCity = stateCity.find(
        (stateCity) => stateCity.state === this.form.state
      );

      this.cityOptions = currentStateCity.cities;
    },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        course: null,
        specialization: null,
        interestedCountry: "",
        highestQualification: "",
        budget: "",
      };
    },
  },

  beforeMount() {
    this.medium = this.$route.query.medium;
    this.getMyStates();
  },
};
</script>
<style scoped>
.form-label-fair {
  font-size: 18px !important;
}
.my-input {
  margin-bottom: 1.7rem;
}
.ielts-hero img {
  width: 70% !important;
  margin-left: 20px;
}
.study-abroad-fair--footer {
  background: rgba(83, 103, 255, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/IeltsDemo/IeltsDemo.vue